<template>
  <BasicPopup
    :title="title"
    :visible="visible"
    @close="close"
  >
    <TransitionExpand mode="out-in">
      <SectionGroup
        v-if="!isVoted"
        gap="medium-large"
      >
        <FormSection
          v-if="showScore"
          appearance="feedback"
          :title="ratingTitle"
        >
          <RatingStarsForm
            class="feedback-modal__stars"
            :disabled="isLoading"
            :fixed="!!score"
            :value="score"
            color="orange"
            @vote="setScore"
          />
        </FormSection>
        <FormSection
          v-if="showLiked"
          appearance="feedback"
          title="Что вам понравилось?"
        >
          <BasicTextarea v-model="liked" :max-length="500" />
        </FormSection>
        <FormSection
          v-if="showDisliked"
          appearance="feedback"
          title="Что не понравилось, было неудобно?"
        >
          <BasicTextarea v-model="disliked" :max-length="500" />
        </FormSection>
        <FormSection
          appearance="feedback"
          title="Что стоит доработать?"
        >
          <BasicTextarea v-model="improve" :max-length="500" />
        </FormSection>
      </SectionGroup>
      <div
        v-else
        class="feedback-modal__message"
      >
        <img src="~images/feedback_received.svg" width="96" height="96" />
        <div class="feedback-modal__text">Спасибо, что уделили время!</div>
      </div>
    </TransitionExpand>

    <template
      v-if="!isVoted"
      #footer
    >
      <BasicButton
        appearance="primary"
        size="l"
        :disabled="isLoading || score === 0"
        @click="sendForm"
      >
        Отправить
      </BasicButton>
    </template>
  </BasicPopup>
</template>

<script>
import { handleRequestError } from 'src/services/api.js';
import { bem } from 'src/utils/bem.js';

import BasicButton from 'src/components/BasicButton/BasicButton.vue';
import BasicTextarea from 'src/components/form/BasicTextarea/BasicTextarea.vue';
import FormSection from 'src/components/form/FormSection/FormSection.vue';
import BasicPopup from 'src/components/popup/BasicPopup/BasicPopup.vue';
import RatingStarsForm from 'src/components/RatingStarsForm/RatingStarsForm.vue';
import SectionGroup from 'src/components/sections/SectionGroup/SectionGroup.vue';
import TransitionExpand from 'src/components/transitions/TransitionExpand/TransitionExpand.vue';

export default {
  name: 'FeedbackModal',
  components: {
    BasicButton,
    BasicPopup,
    BasicTextarea,
    FormSection,
    SectionGroup,
    TransitionExpand,
    RatingStarsForm,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    ratingTitle: {
      type: String,
      default: '',
    },
    chosenScore: {
      type: Number,
      default: 0,
    },
    showScore: {
      type: Boolean,
      default: true,
    },
    action: {
      type: Function,
      required: true,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['success', 'close', 'voted'],
  data() {
    return {
      score: 0,
      liked: '',
      disliked: '',
      improve: '',
      isVoted: false,
      isLoading: false,
    }
  },
  watch: {
    chosenScore(newValue) {
      this.score = newValue;
    }
  },
  methods: {
    bem,
    sendForm() {
      const form = this.buildForm();
      this.isLoading = true;

      this.action(form)
        .then(() => {
          this.isVoted = true;
          this.$emit('voted');
        })
        .catch(handleRequestError)
        .finally(() => {
          this.isLoading = false;
        });
    },
    close() {
      this.clearForm();
      this.$emit('close', this.isVoted);
    },
    clearForm() {
      this.score = 0;
      this.liked = '';
      this.disliked = '';
      this.improve = '';
    },
    buildForm() {
      const { score, liked, disliked, improve } = this;
      const form = {
        score,
        liked,
        disliked,
        improve
      };

      return { form };
    },
    setScore(score) {
      this.score = score;
    }
  },
  computed: {
    showLiked() {
      return this.showScore || (!this.showScore && this.score > 2);
    },
    showDisliked() {
      return this.showScore || (!this.showScore && this.score <= 2);
    },
  },
};
</script>
